module.exports = __webpack_public_path__ + "static/media/2.ceb61eb3.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_190/images/buy/2.png
// module id = 1650
// module chunks = 0